// const config = {
//   BASE_URL: "http://localhost:5000/api"
// };

const config = {
  BASE_URL: process.env.REACT_APP_API_URL || "/api"
};

export default config;